import {Map} from 'immutable';
import {memoize} from '@packages/utilities/memo';
import type {OptimizationPluginContext} from '@packages/systems/optimization/types';

export const getOptimizationPluginContext = memoize(
  (currentVariationId: string | null) => {
    return Map<keyof OptimizationPluginContext, string>({
      currentVariationId: currentVariationId ?? '',
    });
  }
);
